export { Wifi as default } from './Wifi';
